module.exports = __webpack_public_path__ + "img/UNI.d960e49a.svg";